import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'

Vue.use(Router)

const routers = [
  {
    path: '',
    component: () => import('@/layout/Main.vue'),
    redirect: '/',
    // meta: { title: '首页' },
    children:[
      {
        path:'/',
        name:'home',
        component: () => import('@/views/index.vue'),
        meta: {}
      },
      {
        path:'/category',
        name:'category',
        component: () => import('@/views/category.vue'),
        meta: {title: 'Leader & Innovator In Professional Distribution Of Electronic Components '}
      },
      {
        path:'/categoryItem/:id',
        name:'categoryItem',
        component: () => import('@/views/categoryItem.vue'),
        meta: {title: 'Leader & Innovator In Professional Distribution Of Electronic Components '}
      },
      {
        path:'/noticeItem/:type',
        name:'news',
        component: () => import('@/views/noticeItem.vue'),
        meta: {title: 'New | About C & I Company And Electronic Components'}
      },
      {
        path:'/productItem/:cateId',
        name:'productItem',
        component: () => import('@/views/productItem.vue'),
        meta: {title: 'Distributor & Trusted Partner– C & I Electronics Inc.'}
      },
      {
        path:'/aboutUs',
        name:'about us',
        component: () => import('@/views/aboutUs.vue'),
        meta: {title: 'About | About C & I Company And Electronic Components'}
      },
      {
        path:'/manufacturer',
        name:'manufacturer',
        component: () => import('@/views/manufacturer.vue'),
        meta: {title: 'Industry Leading Electronic Component Suppliers '}
      },
      {
        path:'/inquiry',
        name:'inquiry',
        component: () => import('@/views/inquiry.vue'),
        meta: {title: 'Send us inquiry|C & I'}
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('@/views/contactUs.vue'),
        meta: {title: 'ContactUs | C & I'}
      },
      {
        path: '/qualityControl',
        name: 'qualityControl',
        component: () => import('@/views/qualityControl.vue'),
        meta: {title: 'Quality Control | C & I'}
      },
      {
        path: '/productDetail/:id',
        name: 'productDetail',
        component: () => import('@/views/productDetail.vue')
      },
      {
        path: '/articleDetail/:id',
        name: 'articleDetail',
        component: () => import('@/views/articleDetail.vue')
      },
      {
        path: '/support',
        name: 'support',
        component: () => import('@/views/support/index.vue'),
        meta: {title: 'Support | C & I'}
      },
      {
        path: "*",
        component: () => import('@/views/404.vue'),
      }
    ]
  }

]

const route = new Router({
  mode: 'history',
  base: '',
  scrollBehavior: () => ({ y: 0 }),
  routes: routers
})

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


route.beforeEach((to, from, next) => {
  // if (to.path === '/productItem/search' && to.query.proName === from.query.proName) {
  //   next(false);
  // } else {
    // console.log(121)
    if (to.meta.title) {
      document.title = to.meta.title;//获取相应路由信息里面的title
    }
    next();
  // }

  // next()
})

export default route
